import {use} from "i18next";
import {initReactI18next} from "react-i18next";
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/es";
import en from "./locales/en/translations.json";

// eslint-disable-next-line react-hooks/rules-of-hooks
export const i18n = use(initReactI18next)
  .init({
    initAsync: false,
    resources: {en: {translations: en}},
    defaultNS: "translations",
    fallbackLng: "en",
    lng: window.navigator.language,
    interpolation: {
      escapeValue: false,
      format(value, format, locale = "en") {
        if (value instanceof Date) {
          return moment(value)
            .locale(locale)
            .format(format);
        }
        return value;
      }
    },
    react: {
      useSuspense: false
    }
  });
